
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


export interface DanaSupportPageStyles {
    page?: MobiusPageProps;

}

export const danaSupportPageStyles: DanaSupportPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],

        css: css`
        [data-test-selector="PageTitle"] {
            margin-bottom: 0;
        }

        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        padding: 0 16px;
                        padding-bottom: 24px;
                    `,
                        css`
                        padding: 0 24px;
                        padding-bottom: 32px;
                    `,
                        css`
                        padding: 0 24px;
                        padding-bottom: 60px;
                    `,
                        css`
                        padding: 0 40px;
                        padding-bottom: 80px;
                    `,
                    ],
                    "min",
                )}
    `,
    },
};
const mapStateToProps = (state: ApplicationStateDana) => ({
    session: getSession(state),
});

const mapDispatchToProps = {

};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps> & HasHistory;
const styles = danaSupportPageStyles;
const DanaCustomerSupportPage: React.FC<Props> = ({ id, session ,history}) => {
    React.useEffect(() => {
        const userType = session?.properties?.userType ?? "";
        if((!session.isAuthenticated && session.isGuest ) || (session.isAuthenticated && userType === 'ERFQ')){
            history.push("/NotFoundErrorPage");
        }
    }, [session]);

    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="DanaCustomerSupportPage" />
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(DanaCustomerSupportPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const DanaCustomerSupportPageContext = "DanaCustomerSupportPage";
